import { VideoEvent } from '@utils/gtm/ga4/trackVideoEvents';
import cookies from 'js-cookie';
import { PTT_VIDEOS_COOKIE_NAME } from '@adapters/bigcommerce/constants';

export const getPDPVideosCookie = () => {
  const videoEvent = cookies.get('watchedPdpVideos');

  if (videoEvent) {
    try {
      return JSON.parse(videoEvent);
    } catch (error) {
      console.error('Error parsing video event', error);
      return null;
    }
  }

  return null;
};

export const setPDPVideosCookie = (
  interactionLocation: string,
  videoEvent: string
) => {
  const existingCookie = getPDPVideosCookie();
  const existingData = existingCookie ? existingCookie : {};

  const newData = {
    ...existingData,
    [`${window.location.pathname}-${interactionLocation}`]: {
      videoEvent,
    },
  };

  cookies.set('watchedPdpVideos', JSON.stringify(newData));
};

export const getPTTVideoCookie = () => {
  const videoEvent = cookies.get(PTT_VIDEOS_COOKIE_NAME);
  if (videoEvent) {
    try {
      return JSON.parse(videoEvent);
    } catch (error) {
      console.error('Error parsing video event', error);
      return [];
    }
  }

  return [];
};

export const setPTTVideoCookie = (videoEvent: VideoEvent) => {
  const pTtVideos = getPTTVideoCookie();
  const matchingVideoIndex = pTtVideos.findIndex(
    (event: VideoEvent) => event.videoTitle === videoEvent.videoTitle
  );

  if (matchingVideoIndex !== -1) {
    pTtVideos[matchingVideoIndex] = videoEvent;
  } else {
    pTtVideos.push(videoEvent);
  }

  cookies.set(PTT_VIDEOS_COOKIE_NAME, JSON.stringify(pTtVideos));
};

export const getVideoPercent = (percent: number) => {
  if (percent >= 10 && percent < 25) return 10;
  if (percent >= 25 && percent < 50) return 25;
  if (percent >= 50 && percent < 75) return 50;
  if (percent >= 75 && percent < 100) return 75;
  if (percent >= 90) return 100;
  return 0;
};
